
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import api from "~api";
export default {
name: "myDormitory",
components: {
XHeader,Group,Cell,XAddress,Datetime,Selector,XTextarea,XInput,XButton
},
data(){
return{
title: "我的宿舍",
list: '',
}
},
mounted(){
this.getList();
},
methods:{
getList(){
const _this = this
api.post('/orientation/selectDormInfo',{"stuCode": window.localStorage.getItem("stuCode")}).then(function (response) {
console.log(response)
if(response.status===200){
if(response.data.data!==null){
_this.list = response.data.data;
}else {
_this.$msgbox('温馨提示：',"请等待分配宿舍");
_this.$router.replace({name: 'home'});
}
}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/myDormitory.vue